class RecoverableException extends Error {
  public name = 'RecoverableException'
}

export default RecoverableException
